import React from "react";
import { useField } from "formik";
import {
  FormLabel,
  Input,
  InputWrapper,
  PasswordInputElement,
  PasswordInputWrapper,
  ErrorSpan
} from "./styles";

const TextInput = props => {
  const [field, meta] = useField(props);
  const { label, name, type = "text" } = props;

  return (
    <InputWrapper>
      {label ? <FormLabel htmlFor={name}>{label}</FormLabel> : null}
      <Input name={name} type={type} {...field} {...props} autoComplete={name} />
      {meta.touched && meta.error ? <ErrorSpan>{meta.error}</ErrorSpan> : null}
    </InputWrapper>
  );
};

export const PasswordInput = props => {
  const [visible, setVisible] = React.useState(false);
  const [field, meta] = useField(props);
  const { label, name } = props;

  return (
    <InputWrapper>
      {label ? <FormLabel htmlFor={name}>{label}</FormLabel> : null}
      <PasswordInputWrapper>
        <PasswordInputElement
          name={name}
          type={visible ? "text" : "password"}
          {...field}
          {...props}
          autoComplete="current-password"
        />
        <span className="togglePassword" onClick={() => setVisible(!visible)}>
          {visible ? <div /> : <div />}
        </span>
      </PasswordInputWrapper>
      {meta.touched && meta.error ? <ErrorSpan>{meta.error}</ErrorSpan> : null}
    </InputWrapper>
  );
};

export default TextInput;
